<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul></ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
